import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import catchError from '../components/global/CatchError'
import { disconnect } from '../components/global/header/Header'
import { useLangSelected } from './useLangSelected'

export function useVerifyMemberToken() {
    const navigate = useNavigate()
    const lng = useLangSelected()
    const { t } = useTranslation('translation')

    const verifyToken = () => {
        // La validation des tokens est maintenant gérée par le backend via les cookies httpOnly
        // Les erreurs 401 seront automatiquement interceptées par apiClient
        // Cette fonction est conservée pour la compatibilité pendant la migration
    }

    return verifyToken
}
